// Base URL from CRA environment variable.
// Add REACT_APP_BACKEND_URL=http://your-api.com to your .env file.
const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:90';

/**
 * Generic fetch wrapper.
 *
 * Usage:
 *   apiFetch("/users")
 *   apiFetch("/login", { method: "POST", body: JSON.stringify({ ... }) })
 */
export async function apiFetch(endpoint, options = {}, needHeader = true) {
  const res = await fetch(`${BASE_URL}${endpoint}`, {
    ...options,
    ...(needHeader && {
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers || {})
      }
    })
    // Missing 'credentials' avoids CORS failure when backend has Access-Control-Allow-Origin: *
  });

  if (!res.ok) {
    let errorMessage = 'API Error';
    try {
      const body = await res.json();
      errorMessage = body?.message || errorMessage;
    } catch (_) { }
    throw new Error(errorMessage);
  }

  return res.json();
}
